// First-Time User Experience (FTUX)

import {
  INVITE_MODAL_INVITE_LINK_FTUX_TOOLTIP_DISMISSED,
  PUBLISH_SETTINGS_FTUX_TOOLTIP_DISMISSED,
  SHARE_MODAL_FTUX_TOOLTIP_DISMISSED,
  SHARE_WITH_ME_FTUX_TOOLTIP_DISMISSED,
  STORAGE_INCENTIVES_FTUX_BUTTON_DISMISSED,
  STORAGE_INCENTIVES_INVITE_MODAL_BANNER_DISMISSED,
  STORAGE_INCENTIVE_FTUX_INVITE_SENT,
  STORAGE_INCENTIVE_FTUX_VISITED_TRACK_TAB,
  TAGS_STEP_1_FTUX_TOOLTIP_DISMISSED,
  TAGS_STEP_2_FTUX_TOOLTIP_DISMISSED,
  WORKSPACE_CONTACT_IMPORT_INTEGRATIONS_TOOLTIP_DISMISSED,
} from 'constants/localStorage';

import { useStoredStateForUser } from './utils';

export const useShareWithMeFTUXTooltipState = () => {
  return useStoredStateForUser(SHARE_WITH_ME_FTUX_TOOLTIP_DISMISSED);
};

export const useShareModalFTUXTooltipState = () => {
  return useStoredStateForUser(SHARE_MODAL_FTUX_TOOLTIP_DISMISSED);
};

export const useInviteModalInviteLinkFTUXTooltipState = () => {
  return useStoredStateForUser(INVITE_MODAL_INVITE_LINK_FTUX_TOOLTIP_DISMISSED);
};

export const useTagsStep1FTUXTooltipState = () => {
  return useStoredStateForUser(TAGS_STEP_1_FTUX_TOOLTIP_DISMISSED);
};

export const useTagsStep2FTUXTooltipState = () => {
  return useStoredStateForUser(TAGS_STEP_2_FTUX_TOOLTIP_DISMISSED);
};

export const usePublishSettingsFTUXTooltipState = () => {
  return useStoredStateForUser(PUBLISH_SETTINGS_FTUX_TOOLTIP_DISMISSED);
};

export const useStorageIncentivesFTUXButtonState = () => {
  return useStoredStateForUser(STORAGE_INCENTIVES_FTUX_BUTTON_DISMISSED);
};

export const useStorageIncentiveFTUXInviteSent = () => {
  return useStoredStateForUser(STORAGE_INCENTIVE_FTUX_INVITE_SENT);
};

export const useStroageIncentiveFTUXVisitedTrackTab = () => {
  return useStoredStateForUser(STORAGE_INCENTIVE_FTUX_VISITED_TRACK_TAB);
};

export const useStorageIncentiveFTUXInviteModalBannerDismissed = () => {
  return useStoredStateForUser(
    STORAGE_INCENTIVES_INVITE_MODAL_BANNER_DISMISSED
  );
};

export const useContactImportIntegrationsFTUXTooltipState = () => {
  return useStoredStateForUser(
    WORKSPACE_CONTACT_IMPORT_INTEGRATIONS_TOOLTIP_DISMISSED
  );
};
